import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'invites';
const REFERRALS = 'referrals';

export const INVITES_ENDPOINTS = {
  createInvite: () => formatEndpoint('', namespace),
  expireInvite: (inviteId: string) => formatEndpoint(`${inviteId}/expire`, namespace),
  retrieveInvite: (inviteId: string) => formatEndpoint(inviteId, namespace),
  retrieveReferrals: () => formatEndpoint(REFERRALS, namespace),
};
